import { combineReducers } from 'redux';
import authReducer from './auth.reducer';
import bannerAssetsReducer from './bannerAssets.reducer';
import calendarReducer from './calendar.reducer';
import classesReducer from './class.reducer';
import discoverReducer from './discover.reducer';
import feedsReducer from './feed.reducer';
import geoReducer from './geo.reducer';
import insightsReducer from './insights.reducer';
import notificationReducer from './notification.reducer';
import offerReducer from './offer.reducer';
import orgReducer from './org.reducer';
import pendingRequestReducer from './pendingRequest.reducer';
import userDataReducer from './userData.reducer';

const rootReducer = combineReducers({
  auth: authReducer,
  org: orgReducer,
  classes: classesReducer,
  userData: userDataReducer,
  geo: geoReducer,
  calendar: calendarReducer,
  insights: insightsReducer,
  feeds: feedsReducer,
  pendingRequest: pendingRequestReducer,
  offers: offerReducer,
  notification: notificationReducer,
  bannerAssets: bannerAssetsReducer,
  discover: discoverReducer
});

export default rootReducer;
